export const formatPhoneNumber = (phone?: string) =>
  phone?.startsWith("0") ? `+381${phone.substring(1)}` : phone;

export const maxChar = (str: string = "", maxLength: number = 30) =>
  str.length > maxLength ? `${str.substring(0, maxLength)}...` : str;
